import type { CSSProperties } from 'react'

import { Standbild } from './Standbild'

/**
 * An `<img>` that asks again once the network is back (1.50.0): the trip's
 * cover, the thumbnails in the chat list, the background's preview.
 *
 * **Since 1.78.0 it is `Standbild` under its old name.** The two were two
 * answers to one question -- "a picture from the server that may fail" --
 * and each knew only half: this one the net coming back, `Standbild` the
 * picture that is not there yet. The reason why a plain `<img>` does
 * neither stands at `Standbild` and `useNetzbild`.
 */
export function Netzbild(props: {
  src: string
  className?: string
  style?: CSSProperties
  loading?: 'lazy' | 'eager'
}) {
  return <Standbild {...props} />
}
